<template>
  <!-- 封禁用户设备新增对话框 -->
  <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :modal-append-to-body="true" append-to-body
    close-on-click-modal @closed="handleClose">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="命中val" prop="hitVal">
        <el-input v-model="form.hitVal" size="small" placeholder="请输入命中val"></el-input>
      </el-form-item>
      <!-- 类型：1-用户 2-设备 -->
      <el-form-item label="类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio label="1">用户</el-radio>
          <el-radio label="2">设备</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 云桌面封禁 0-否 1-是 -->
      <el-form-item label="云桌面封禁" prop="cloudDeskFlag">
        <el-radio-group v-model="form.cloudDeskFlag">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 云镜像封禁 0-否 1-是-->
      <el-form-item label="云镜像封禁" prop="cloudMirrorFlag">
        <el-radio-group v-model="form.cloudMirrorFlag">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="好友分享封禁" prop="friendShareFlag">
        <el-radio-group v-model="form.friendShareFlag">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 局域网镜像封禁：0-否 1-是 -->
      <el-form-item label="局域网镜像封禁" prop="lanMirrorFlag">
        <el-radio-group v-model="form.lanMirrorFlag">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 本地音频封禁：0-否 1-是 -->
      <el-form-item label="本地音频封禁" prop="localAudioFlag">
        <el-radio-group v-model="form.localAudioFlag">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 本地图片封禁：0-否 1-是 -->
      <el-form-item label="本地图片封禁" prop="localPicFlag">
        <el-radio-group v-model="form.localPicFlag">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 本地视频封禁：0-否 1-是 -->
      <el-form-item label="本地视频封禁" prop="localVideoFlag">
        <el-radio-group v-model="form.localVideoFlag">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 在线音频封禁：0-否 1-是 -->
      <el-form-item label="在线音频封禁" prop="onlineAudioFlag">
        <el-radio-group v-model="form.onlineAudioFlag">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 	在线图片封禁：0-否 1-是 -->
      <el-form-item label="在线图片封禁" prop="onlinePicFlag">
        <el-radio-group v-model="form.onlinePicFlag">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 在线视频封禁：0-否 1-是 -->
      <el-form-item label="在线视频封禁" prop="onlineVideoFlag">
        <el-radio-group v-model="form.onlineVideoFlag">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 备注 -->
      <el-form-item label="备注" prop="remark">
        <el-input show-word-limit maxlength="9999" type="textarea" size="small" v-model="form.remark"
          placeholder="请输入备注" clearable></el-input>
      </el-form-item>
    </el-form>
    <!-- 保存和取消 -->
    <div class="btn-container" style="text-align: right; margin-top: 20px">
      <el-button size="small" type="primary" @click="save">保存</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import { addDevice, editDevice } from '@/api/security/userDevice'
import Message from '@/components/Message'
export default {
  name: 'WebSaaSAdd',
  inject: ['loadList'],
  computed: {
    title() {
      return this.optionType === 'add' ? '新增' : '编辑';
    },
  },
  data() {
    return {
      /** 操作类型 */
      optionType: 'add',
      /** 对话框显隐 */
      dialogVisible: false,
      /** 表单 */
      form: {
        /** 类型 */
        type: '1',
        /** 命中val */
        hitVal: '',
        /** 云桌面封禁 */
        cloudDeskFlag: '0',
        /** 云镜像封禁 */
        cloudMirrorFlag: '0',
        /** 好友分享封禁 */
        friendShareFlag: '0',
        /** 局域网镜像封禁 */
        lanMirrorFlag: '0',
        /** 本地音频封禁 */
        localAudioFlag: '0',
        /** 本地图片封禁 */
        localPicFlag: '0',
        /** 本地视频封禁 */
        localVideoFlag: '0',
        /** 在线音频封禁 */
        onlineAudioFlag: '0',
        /** 在线图片封禁 */
        onlinePicFlag: '0',
        /** 在线视频封禁 */
        onlineVideoFlag: '0',
        /** 备注 */
        remark: '',
      },
      /** 表单验证规则 */
      rules: {
        /** 命中val */
        hitVal: [
          { required: true, message: '请输入命中val', trigger: 'blur' },
        ],
        /** 类型 */
        type: [
          { required: true, message: '请选择类型', trigger: 'change' },
        ],
        /** 云桌面封禁 */
        cloudDeskFlag: [
          { required: true, message: '请选择云桌面封禁', trigger: 'change' },
        ],
        /** 云镜像封禁 */
        cloudMirrorFlag: [
          { required: true, message: '请选择云镜像封禁', trigger: 'change' },
        ],
        friendShareFlag: [
          { required: true, message: '请选择好友分享封禁', trigger: 'change' },
        ],
        /** 局域网镜像封禁 */
        lanMirrorFlag: [
          { required: true, message: '请选择局域网镜像封禁', trigger: 'change' },
        ],
        /** 本地音频封禁 */
        localAudioFlag: [
          { required: true, message: '请选择本地音频封禁', trigger: 'change' },
        ],
        /** 本地图片封禁 */
        localPicFlag: [
          { required: true, message: '请选择本地图片封禁', trigger: 'change' },
        ],
        /** 本地视频封禁 */
        localVideoFlag: [
          { required: true, message: '请选择本地视频封禁', trigger: 'change' },
        ],
        /** 在线音频封禁 */
        onlineAudioFlag: [
          { required: true, message: '请选择在线音频封禁', trigger: 'change' },
        ],
        /** 在线图片封禁 */
        onlinePicFlag: [
          { required: true, message: '请选择在线图片封禁', trigger: 'change' },
        ],
        /** 在线视频封禁 */
        onlineVideoFlag: [
          { required: true, message: '请选择在线视频封禁', trigger: 'change' },
        ],

        /** 备注 */
        remark: [
          { max: 9999, message: '备注最多输入9999个字符', trigger: 'blur' },
        ],
      },
    };
  },

  methods: {
    /** 取消 */
    cancel() {
      this.hide();
    },
    /** 保存 */
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.optionType === 'add') {
            this.add()
          } else {
            this.edit()
          }
        }
      });
    },
    /** 新增 */
    async add() {
      const params = _.cloneDeep(this.form)
      const { data } = await addDevice(params)
      if (data.code === 200) {
        Message.success('新增成功')
        this.hide()
        this.loadList()
      }
    },
    /** 编辑 */
    async edit() {
      const params = _.cloneDeep(this.form)
      const { data } = await editDevice(params)
      if (data.code === 200) {
        Message.success('编辑成功')
        this.hide()
        this.loadList()
      }
    },
    //^ ^--------------对话框自身的方法-------------^ ^
    show(optionType, row) {
      this.optionType = optionType || 'add'
      if (row) {
        this.form = { ...row };
      }
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.form.type = '1'
      this.form.cloudDeskFlag = '0'
      this.form.cloudMirrorFlag = '0'
      this.form.friendShareFlag = '0'
      this.form.lanMirrorFlag = '0'
      this.form.localAudioFlag = '0'
      this.form.localPicFlag = '0'
      this.form.localVideoFlag = '0'
      this.form.onlineAudioFlag = '0'
      this.form.onlinePicFlag = '0'
      this.form.onlineVideoFlag = '0'
      this.form.remark = ''
      /** 清空表单验证规则 */
      this.$refs.form.clearValidate();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
  min-height: 70px !important;
}

::v-deep .el-form-item {
  display: flex;
  align-items: center;

  .el-form-item__content {
    margin-left: 0 !important;
    flex: 1;
    display: flex;

    .el-radio-group {
      flex: 1;
      display: flex;

      .left {
        flex: 1;
      }

      .right {
        flex: 1;
      }
    }
  }
}
</style>
